import React, { useContext, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router";
//
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import useLocaleRoute from "../../../../../../../common/hooks/useLocaleRoute";
import useModulePublic from "../../../../../../hooks/useModulePublic";
import IconPopup from "../../../../../../../common/components/popup/IconPopup";
import { StoreContext } from "../../../../../../../store/StoreProvider";
import CommonList from "../../../common/CommonList";
import CommonListItem from "../../../common/CommonListItem";
import PopupEdit from "../../../common/PopupEdit";
import PopupListItem from "../../../common/PopupListItem";
//
import Act from "../../../../../../../store/actions";
import { MODULE_ID } from "../../../../../../../config/CONSTANTS";
import urls from "../../../../../../../api/project/ApiUrls";
//

import { deleteGroupFile } from "../../../../../service/datasetService";

const popupMenuPosition = {
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "left",
  },
};

const StyledList = CommonList;

const AccordionDetailChildren = () => {
  // props

  // route,intl
  const intl = useIntl();
  const navigate = useNavigate();
  // store
  const [state, dispatch] = useContext(StoreContext);
  const { user, sna } = state;
  const { locale, group } = user;
  const { dataset } = sna;
  // local state
  const [listItems, setListItems] = useState(dataset.group || []);
  const [listItemFocus, setListItemFocus] = useState(null);
  const [popupPageIdx, setPopupPageIdx] = useState(0);
  const [popPageCtx, setPopPageCtx] = useState({});
  const [popChooseOptions, setPopChooseOptions] = useState([]);
  const [popEditInput, setPopEditInput] = useState("");
  // hooks
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );
  const { handlePublic } = useModulePublic();

  const disabledListItemMoreAct = !handlePublic(
    MODULE_ID.snaSidebarFileGroupPrivateEdit
  );

  useEffect(() => {
    if (Array.isArray(dataset.group)) {
      setListItems(dataset.group);
    }
  }, [dataset.group]);

  const handleListItemCheckChange = (e, listItem) => {
    const { checked } = e.target;
    const newItems = [];
    listItems.forEach((item) => {
      if (item.id === listItem.id) {
        newItems.push({
          ...item,
          checked,
        });
      } else {
        newItems.push(item);
      }
    });
    setListItems(newItems);
    dispatch({
      type: Act.SNA_CUR_DATASET,
      payload: {
        ...dataset,
        group: [...newItems], // 儲存到 group
      },
    });
  };

  const refreshDataset = () => {
    // 因為 personal 及 group 可能共有 dataset, 所以一併搜尋
    // 重新搜尋 personal dataset
    dispatch({
      type: Act.SNA_REFRESH_PERSONAL_DATASET,
      payload: true,
    });
    // 重新搜尋 group dataset
    dispatch({
      type: Act.SNA_REFRESH_GROUP_DATASET,
      payload: true,
    });
  };

  const handleDeleteListItem = (listItem) => () => {
    // 儲存至 firebase, 儲存成功的話重新抓取 dataset 資料
    const onDeleteSuccess = () => {
      dispatch({
        type: Act.COMMON_SET_SUCCESS_MESSAGE,
        payload: {
          open: true,
          content: intl.formatMessage({
            id: "sna.sidebar.filetool.group.delete.file.success",
            defaultMessage: "已刪除檔案",
          }),
        },
      });
      // 因為 personal 及 group 可能共有 dataset, 所以一併搜尋
      refreshDataset();
    };
    const onDeleteError = (error) => {
      dispatch({
        type: Act.COMMON_SET_ERROR_MESSAGE,
        payload: {
          open: true,
          content: error.message,
        },
      });
    };

    dispatch({
      type: Act.SNA_DIALOG_CONTEXT,
      payload: {
        openSignal: true,
        title: intl.formatMessage({
          id: "sna.sidebar.filetool.group.delete.file.modal.title",
          defaultMessage: "確定要刪除資料集嗎？",
        }),
        contentText: intl.formatMessage({
          id: "sna.sidebar.filetool.group.delete.file.modal.text",
          defaultMessage: "刪除後將無法復原此資料集。",
        }),
        onYes: () =>
          deleteGroupFile(
            listItem?.uid, // fileId
            group.uid, // groupId
            onDeleteSuccess,
            onDeleteError
          ),
        yesText: intl.formatMessage({
          id: "sna.sidebar.filetool.group.delete.file.modal.confirm",
          defaultMessage: "刪除",
        }),
        noText: intl.formatMessage({
          id: "sna.sidebar.filetool.group.delete.file.modal.cancel",
          defaultMessage: "取消",
        }),
      },
    });
  };

  const handleEditInputChange = (e) => {
    setPopEditInput(e.target.value);
  };

  // todo: 目前團隊資料集的名稱來自個人資料集分享, 所以資料集名稱由個人使用者控制
  const handleEditSubmit = () => {
    // todo: 儲存至 firebase
    // eslint-disable-next-line no-console
    console.log("popEditInput", popEditInput);
  };

  const getPopupPageEdit = () => null;
  // todo: 目前團隊資料集的名稱來自個人資料集分享, 所以資料集名稱由個人使用者控制
  // ({
  //   children: (
  //     <PopupListItem
  //       text={intl.formatMessage({
  //         id: "sna.sidebar.filetool.rename.file",
  //         defaultMessage: "重新命名",
  //       })}
  //       onClick={() => setPopupPageIdx(1)}
  //       withNextStep
  //     />
  //   ),
  // });

  // soft delete
  const getPopupPageDelete = () => ({
    children: (
      <PopupListItem
        text={intl.formatMessage({
          id: "sna.sidebar.filetool.delete.file",
          defaultMessage: "刪除資料集",
        })}
        onClick={handleDeleteListItem(listItemFocus)}
        withNextStep={false}
      />
    ),
  });

  const popupPage0 = {
    body: [getPopupPageEdit(), getPopupPageDelete()].filter((item) => !!item),
  };

  const disabledEditSubmitBtn = !popEditInput;
  // 變更檔案名稱
  const popupPage1 = {
    // body: popup 主體
    body: (
      <PopupEdit
        context={listItemFocus}
        title={intl.formatMessage({
          id: "sna.sidebar.filetool.edit.filename",
          defaultMessage: "重新命名",
        })}
        inputLabel={intl.formatMessage({
          id: "sna.sidebar.filetool.edit.filename.label",
          defaultMessage: "資料集名稱",
        })}
        onInputChange={handleEditInputChange}
        onSubmit={() => handleEditSubmit()}
        submitText={intl.formatMessage({
          id: "sna.sidebar.filetool.edit.filename.confirm",
          defaultMessage: "確認",
        })}
        disabledBtn={disabledEditSubmitBtn}
      />
    ),
    // footer
    footer: null,
  };

  // popup 所有分頁
  const popupPages = [popupPage0, popupPage1];

  // 當選擇的 group 變更 or pageIdx 便更時, 重新產生 popup 內容
  useEffect(() => {
    setPopPageCtx(popupPages[popupPageIdx]);
  }, [popupPageIdx, popEditInput, listItemFocus]);

  const getIconButtonProps = (uGroup) => ({
    onButtonIconClick: () => {
      setListItemFocus(uGroup);
    },
    sx: {
      color: "#fff",
    },
    disabled: disabledListItemMoreAct,
  });

  const getMenuProps = () => ({
    ...popPageCtx,
    ...popupMenuPosition,
    onClose: () => setPopupPageIdx(0),
  });

  return (
    <StyledList>
      {listItems.map((uFile, idx) => (
        <CommonListItem
          key={idx.toString()}
          withCheckbox
          withAvatar={false}
          checked={uFile.checked}
          onCheckboxChange={handleListItemCheckChange}
          context={{
            id: uFile?.uid,
            textPrimary: uFile.displayName,
          }}
          avatarSize="normal"
          secondaryAction={
            <IconPopup
              icon={<MoreHorizIcon />}
              iconButtonProps={{
                ...getIconButtonProps(uFile),
              }}
              menuProps={{
                ...getMenuProps(),
              }}
            />
          }
          darkMode
        />
      ))}
    </StyledList>
  );
};

export default AccordionDetailChildren;
